
import { useTranslation } from 'react-i18next';
import { PlanLayout } from "@/components/plans/PlanLayout";
import { NotificationSection } from "@/components/plans/safety-net/NotificationSection";
import { OverviewSection } from "@/components/plans/safety-net/OverviewSection";
import { LoanDetailsSection } from "@/components/plans/safety-net/LoanDetailsSection";
import { ResourcesSection } from "@/components/plans/safety-net/ResourcesSection";
import { FuturePlansSection } from "@/components/plans/safety-net/FuturePlansSection";

const SafetyNetPage = () => {
  const { t } = useTranslation();
  return (
    <PlanLayout
      title={t('plans_detail.safety_net.title')}
      imageUrl="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40"
    >
      <NotificationSection />
      <OverviewSection />
      <LoanDetailsSection />
      <ResourcesSection />
      <FuturePlansSection />
    </PlanLayout>
  );
};

export default SafetyNetPage;
